// extracted by mini-css-extract-plugin
export default {"containerDefault":"Loader_containerDefault__bEunH"};